/**
 * Find the best team member by email, prioritizing the most complete account.
 * Priority: has categoryId > matching orgId > has roles > email confirmed > has fcmToken > has photo
 */
export function findBestTeamByEmail<T extends {
  id: string;
  email?: string;
  categoryId?: string;
  orgId?: string | null;
  roles?: string[];
  role?: string;
  emailConfirmed?: boolean;
  photo?: string;
  name?: string;
  fcmToken?: string | null;
}>(
  teamList: T[],
  email: string | undefined | null,
  currentOrgId?: string | null,
): T | undefined {
  if (!email) return undefined;
  const clean = email.toLowerCase().trim();
  const matches = teamList.filter(s => s.email?.toLowerCase().trim() === clean);
  if (matches.length === 0) return undefined;
  if (matches.length === 1) return matches[0];

  // Score each match and pick the best
  const scored = matches.map(s => {
    let score = 0;
    if (s.categoryId) score += 100;
    if (currentOrgId && s.orgId === currentOrgId) score += 50;
    if ((s.roles || []).length > 0) score += 20;
    if (s.role) score += 10;
    if (s.emailConfirmed) score += 5;
    if (s.fcmToken) score += 5;  // prioritize accounts with push notification token
    if (s.photo) score += 2;
    // Prefer accounts with actual names (not just email prefix)
    if (s.name && s.name !== s.email?.split('@')[0]) score += 1;
    return { member: s, score };
  });
  scored.sort((a, b) => b.score - a.score);
  return scored[0].member;
}
